'use client'

import { ButtonLink, FeatureFlag } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Icon, Row, Skeleton } from '@repo/ui/components'
import { useUserAuthDetails } from '@repo/services'
import { Cookie } from '@repo/tools'

export const DashboardAccountHeaderLayout = () => {
  const { t } = useTranslate()
  const { data: { data: authDetails } = {}, isPending } = useUserAuthDetails()
  const isLoggedIn = !!Cookie.get('access_token')
  return (
    <Row className='gap-xs'>
      {isPending ? (
        <Skeleton className='w-10 h-10' />
      ) : authDetails ? (
        <>
          <FeatureFlag flagKey='wallet'>
            <ButtonLink
              variant='transparent'
              color='neutral'
              size='xs'
              href='/wallet'
              startIcon={<Icon name='WalletLine' size='xs' />}
            >
              {t('profileLayout_wallet')}
            </ButtonLink>
          </FeatureFlag>
          <ButtonLink
            variant='transparent'
            color='neutral'
            size='xs'
            href='/profile/account'
            startIcon={<Icon name='PersonCircleLine' size='xs' />}
          >
            {authDetails?.details?.firstName}{' '}
            {authDetails?.details?.lastName || t(`profileLayout_my_account`)}
          </ButtonLink>
        </>
      ) : !isLoggedIn && !isPending ? (
        <ButtonLink variant='fill' color='neutral' size='sm' href='/auth/login'>
          {t('profileLayout_login')} | {t('profileLayout_register')}
        </ButtonLink>
      ) : null}
    </Row>
  )
}
